import React, { useState, useEffect, useRef } from 'react';
import TreeviewTable from './treeviewTable.js'; // Создадим этот компонент позже
import { Loading } from './loading.js';
import { Turl } from './tUrl.js'
import { formatIntegerWithCommas } from './formatIntegerWithCommas.js';
import { t } from 'ttag';
import './css/PartnersBlock.css'; // Создайте этот CSS файл
import { mixpanel } from './mp.js';

// Telegram Mini Apps API (доступен глобально в Mini Apps)
const tg = window.Telegram ? window.Telegram.WebApp : null;

function PartnersBlock() {
    const [isCopied, setIsCopied] = useState(false);
    const [mData, setmData] = useState(null);
    const hasFetchedData = useRef(false); // Ref для отслеживания первого вызова

    useEffect(() => {
        const getAfilate = async () => {
            hasFetchedData.current = true;
            try {
                const _userData = tg ? tg.initData : null;
                let userData = { initData: _userData }

                if (userData) {
                    const response = await fetch(Turl + '/api/afilate2', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(userData)
                    });

                    if (!response.ok) {
                        throw new Error(`HTTP error! Status: ${response.status}`);
                    }
                    let rd = await response.json();

                    setmData(rd)

                } else {
                    console.warn("Telegram user data not available.");
                }

            } catch (error) {
                console.error('Authentication error:', error);
            }
        };

        if (!mData && !hasFetchedData.current) {
            getAfilate();
        }
    }, [mData]);

    if (!mData)
        return <Loading />;
    hasFetchedData.current = false;

    const copyToClipboard = async () => {
        if (mData.ref_link && mData.ref_link.includes('Please activate')) {
            alert(mData.ref_link);
            return;
        }
        mixpanel.track('partner-copyToClipboard')
        try {
            await navigator.clipboard.writeText(mData.ref_link);
            setIsCopied(true);
            setTimeout(() => setIsCopied(false), 2000); // Сброс состояния через 2 секунды
        } catch (err) {
            console.error('Failed to copy text: ', err);
        }
    };


    return (
        <div className="p-container">
            {/* --- Блок 1: Копирование ссылки --- */}
            <div className="p-copy-container">
                <div className="p-copy-text">
                    {mData.ref_link}
                </div>
                <button className="p-copy-button" onClick={copyToClipboard}>
                    {isCopied ? t`Copied!` : t`Copy`}
                </button>
            </div>

            {/* --- Блок 2: Статистика --- */}
            <div className="p-main-block p-stats-container">
                <div className="p-stat-item">
                    <span className="p-stat-label">{t`Your partners`}</span>
                    <span className="p-stat-value">{formatIntegerWithCommas(mData.inentr)}</span>
                </div>
                <div className="p-stat-item">
                    <span className="p-stat-label">{t`Your levels`}</span>
                    <span className="p-stat-value">{mData.levels}</span>
                </div>
                <div className="p-stat-item">
                    <span className="p-stat-label">{t`Total partners`}</span>
                    <span className="p-stat-value">{formatIntegerWithCommas(mData.inentrt)}</span>
                </div>
            </div>

            {/* --- Блок 3: Рефералы (Таблица) --- */}
            <div className="p-main-block">
                <div className="p-block-title">{t`Referal`}</div>
                <TreeviewTable data={mData.treeData} />
            </div>
        </div>
    );
}

export { PartnersBlock };